module.exports = __webpack_public_path__ + "img/interrupt_icon.1e58ef2b.svg";